import axios from 'axios';

const UPDATE_SALESPERSON = 'UPDATE_SALESPERSON';
const ADD_SALESPERSON_STARTED = 'ADD_SALESPERSON_STARTED';
const ADD_SALESPERSON_FAILURE = 'ADD_SALESPERSON_FAILURE';

export function updateSalesperson(salesperson, contractId = null) {
  if (contractId) {
    return addSalesperson(salesperson, contractId)
  }

  return { type: UPDATE_SALESPERSON, payload: salesperson }
}

export function addSalesperson(salesperson, contractId) {
  return (dispatch) => {
    dispatch(addSalespersonStarted())

    axios.put(`/contracts/${contractId}/add-salesperson/`, { salesperson_id: salesperson.id })
      .then(() => dispatch(updateSalesperson(salesperson)))
      .catch((err) => dispatch(addSalespersonFailure(err.response.data.ui_message)))
  }
}

const addSalespersonStarted = () => ({ type: ADD_SALESPERSON_STARTED })
const addSalespersonFailure = (error) => ({ type: ADD_SALESPERSON_FAILURE, payload: error })

function salespersonReducer(state, action) {
  switch (action.type) {
    case ADD_SALESPERSON_STARTED:
      return {
        ...state,
        loading: true,
      }
    case ADD_SALESPERSON_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case UPDATE_SALESPERSON:
      return {
        ...state,
        loading: false,
        salesperson: action.payload,
      }
    default:
      return state
  }

  return state;
}

export default salespersonReducer;
